<div class="popup-container tlms-popup">
  <header>
    <div class="header" style="display:block"> {{heading}}</div>
    <button class="close" style="top:-3px" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <div class="body">
    <label class="catlabel"> {{description}}</label>
  </div>
  <div class="cfooter d-flex justify-content-between align-items-center popup-footer">
    <button (click)="onNoClick()" class="mCancel"> CANCEL</button>
    <button mat-raised-button class="black-btn" style="display: inline;" (click)="saveClick()">CONFIRM</button>
  </div>
</div>